import ViewExportContainer from '../ViewExport/ViewExportContainer';

const getTableData = (data, columns) => {
  const headers = columns.map(({ Header }) => Header);

  const rows = [];

  data.forEach(({ building, name, active }) => {
    const isActive = active ? 'Active' : 'Inactive';

    rows.push([name, building?.name, isActive]);
  });
  return { headers, rows };
};

const AmenitiesExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default AmenitiesExport;
